export default __webpack_public_path__ + "static/media/hmd_logo.a10505ca.svg";